module.exports = __webpack_public_path__ + "static/img/COC2021-27.1511fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-27.jpg
// module id = eRUy
// module chunks = 0